import { FC } from 'react';
import { Box, Typography, Collapse } from '@mui/material';

import styles from './EmergencyContacts.module.scss';
import { EmergencyContact } from '../../../../../../types/trip.types';
import { EmailIcon, PhoneIcon } from '../../../../../../components/Icons';
import HandShakeIcon from '../../../../../../assets/icons/user-info/hand-shake.png';

interface EmergencyContactsProps {
  contacts: EmergencyContact[];
  isExpanded: boolean;
}

const EmergencyContacts: FC<EmergencyContactsProps> = ({ contacts, isExpanded }) => {
  const getContactDisplayName = (contact: EmergencyContact) => {
    if (contact.first_name || contact.last_name) {
      return `${contact.first_name || ''} ${contact.last_name || ''}`.trim();
    }
    return contact.email || 'Unknown Contact';
  };

  return (
    <Collapse in={isExpanded}>
      <Box className={styles.emergencyContacts}>
        {contacts.length === 0 ? (
          <Typography
            variant="h11"
            className={styles.noContactsText}
          >
            No emergency contacts added yet
          </Typography>
        ) : (
          <>
            {contacts.map(contact => (
              <Box
                key={contact.id}
                className={styles.contactItem}
              >
                <Box className={styles.contactInfo}>
                  <Typography
                    variant="h10Semibold"
                    className={styles.contactName}
                  >
                    <img
                      src={HandShakeIcon}
                      alt="hand shake icon"
                      className={styles.icon}
                    />
                    {getContactDisplayName(contact)}
                  </Typography>
                  {contact.relationship && (
                    <Typography
                      variant="h10"
                      className={styles.contactRelationship}
                    >
                      • {contact.relationship}
                    </Typography>
                  )}
                </Box>

                <Box className={styles.contactDetails}>
                  {contact.email && (
                    <Box className={styles.contactDetail}>
                      <EmailIcon
                        size={16}
                        color="#5E6A81"
                      />
                      <Typography variant="h10">{contact.email}</Typography>
                    </Box>
                  )}
                  {contact.phone_number && (
                    <Box className={styles.contactDetail}>
                      <PhoneIcon
                        size={16}
                        color="#5E6A81"
                      />
                      <Typography variant="h10">{contact.phone_number}</Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            ))}
          </>
        )}
      </Box>
    </Collapse>
  );
};

export default EmergencyContacts;
